import React, { createContext, useContext, useState } from 'react';
import { fetchBootstrapData } from '../api/endpoints/bootstrap';
import { isAbortError } from '../api/isAbortError';
import useAbortableEffect from '../hooks/useAbortableEffect';

const AppDataContext = createContext(null);

export function AppDataProvider({ children }) {
    const [appData, setAppData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useAbortableEffect(async (signal, isActive) => {
        try {
            const res = await fetchBootstrapData({ signal });
            if (!isActive()) return;
            if (res.status === 'OK') {
                setAppData(res.data);
            } else {
                setError(res.message || 'Failed to load app data');
            }
        } catch (err) {
            if (isAbortError(err) || !isActive()) return;
            setError(err.message || 'Failed to load app data');
        } finally {
            if (isActive()) setLoading(false);
        }
    }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Laden...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'red' }}>
                <div>Fout bij het laden van applicatiedata: {error}</div>
            </div>
        );
    }

    return (
        <AppDataContext.Provider value={appData}>
            {children}
        </AppDataContext.Provider>
    );
}

export function useAppData() {
    const context = useContext(AppDataContext);
    if (context === null) {
        throw new Error('useAppData must be used within an AppDataProvider');
    }
    return context;
}

export default AppDataContext;
